import { computed } from 'vue';
import { useAccount } from './useAccount';
import { useAdmin } from './useAdmin';

export function usePaymentStatus() {
  const { accountId, currentAccount, isOnChatwootCloud } = useAccount();
  const { isAdmin: canManagePayment } = useAdmin();

  // WGPT Change - Billing: the subscription lives in wgpt_attributes, and the
  // account is past due only once its paid period has ended.
  // const isPastDue = computed(
  //   () =>
  //     isOnChatwootCloud.value &&
  //     currentAccount.value?.billing_provider === 'stripe' &&
  //     currentAccount.value?.custom_attributes?.subscription_status ===
  //       'past_due'
  // );
  const isPastDue = computed(() => {
    const subscription = currentAccount.value?.wgpt_attributes;
    if (!isOnChatwootCloud.value || !subscription) return false;

    const { subscription_status: status, subscription_ends_on: endsOn } =
      subscription;
    return status === 'past_due' && !!endsOn && new Date(endsOn) < new Date();
  });

  return { accountId, isPastDue, canManagePayment };
}
